import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c23474f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "statistics-empty"
};
const _hoisted_2 = {
  key: 1,
  class: "statistics-panel"
};
const _hoisted_3 = {
  class: "stat-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送订单数", -1));
const _hoisted_5 = {
  class: "value"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "笔", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_8 = {
  class: "stat-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送总金额(CNY)", -1));
const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "元", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_13 = {
  class: "stat-item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "复送总金额(USD)", -1));
const _hoisted_15 = {
  class: "value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "美元", -1));
import { queryOrderStatistics } from '@/api/orderApi';
import { awaitWrap, OK } from '@/common';
import { Empty, message } from 'ant-design-vue';
import { getOrderPermissionIds, useIncomePermissionQuery } from '@/hooks/useIncomePermissionQuery';
const __default__ = {
  name: 'DuplicateStatic'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, {
    expose
  }) {
    const orderNum = ref(0);
    const totalAmount = ref(0);
    const totalAmountUsd = ref(0);
    const duplicateRate = ref(0);
    const {
      loading,
      queryError,
      state,
      emptyDescription,
      begin
    } = useIncomePermissionQuery();
    const hasStatistics = ref(false);
    const getOrderStatistics = async obj => {
      const permissionRequest = begin(getOrderPermissionIds(obj));
      hasStatistics.value = false;
      orderNum.value = totalAmount.value = totalAmountUsd.value = duplicateRate.value = 0;
      try {
        const [err, res] = await awaitWrap(queryOrderStatistics({
          ...obj,
          reshipStatusList: ['10', '20'],
          pageArrow: '1',
          pageSize: 10
        }));
        if (!permissionRequest.isCurrent()) return;
        if (err || (res === null || res === void 0 ? void 0 : res.code) !== OK) {
          permissionRequest.fail();
          if (err) message.error(err.message);
          return;
        }
        if (res && res.code === OK) {
          var _data$reshipSum, _data$reshipCnyAmount, _data$reshipUsdAmount;
          const data = res.data;
          permissionRequest.accept(res);
          hasStatistics.value = (data === null || data === void 0 ? void 0 : data.reshipSum) != null;
          orderNum.value = (_data$reshipSum = data === null || data === void 0 ? void 0 : data.reshipSum) !== null && _data$reshipSum !== void 0 ? _data$reshipSum : 0;
          totalAmount.value = (_data$reshipCnyAmount = data === null || data === void 0 ? void 0 : data.reshipCnyAmount) !== null && _data$reshipCnyAmount !== void 0 ? _data$reshipCnyAmount : 0;
          totalAmountUsd.value = (_data$reshipUsdAmount = data === null || data === void 0 ? void 0 : data.reshipUsdAmount) !== null && _data$reshipUsdAmount !== void 0 ? _data$reshipUsdAmount : 0;
          duplicateRate.value = data !== null && data !== void 0 && data.reshipSumRate ? Number((Number(data.reshipSumRate) * 100).toFixed(2)) : 0;
        }
      } catch (error) {
        permissionRequest.fail();
      } finally {
        permissionRequest.finish();
      }
    };
    expose({
      getOrderStatistics,
      permissionState: state
    });
    return (_ctx, _cache) => {
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_statistic = _resolveComponent("a-statistic");
      const _component_a_spin = _resolveComponent("a-spin");
      return !_unref(state).allDenied ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        spinning: _unref(loading)
      }, {
        default: _withCtx(() => [_unref(queryError) || !hasStatistics.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_empty, {
          image: _unref(Empty).PRESENTED_IMAGE_SIMPLE,
          description: _unref(emptyDescription)
        }, null, 8, ["image", "description"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_statistic, {
          value: orderNum.value
        }, {
          suffix: _withCtx(() => [_hoisted_6]),
          _: 1
        }, 8, ["value"])])]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_statistic, {
          value: totalAmount.value
        }, {
          suffix: _withCtx(() => [_hoisted_11]),
          _: 1
        }, 8, ["value"])])]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_statistic, {
          value: totalAmountUsd.value
        }, {
          suffix: _withCtx(() => [_hoisted_16]),
          _: 1
        }, 8, ["value"])])])]))]),
        _: 1
      }, 8, ["spinning"])) : _createCommentVNode("", true);
    };
  }
});